//  export const API_BASE_URL = "https://one-two-one-backend-production.up.railway.app" || "http://localhost:5000"
// export const API_BASE_URL = "http://localhost:5000"
// export const API_BASE_URL = "https://one-two-one-backend-production-b145.up.railway.app/"
export const API_BASE_URL = "https://one-two-one-backend.onrender.com/"
export const APP_BASE_URL = "https://121property.in"
export const DEFAULT_TIMEOUT = 15000;

export const MeasurementId = "G-YF8R2H4Z7D";

